import { render, staticRenderFns } from "./house-album.vue?vue&type=template&id=52afe617&scoped=true&"
import script from "./house-album.vue?vue&type=script&lang=js&"
export * from "./house-album.vue?vue&type=script&lang=js&"
import style0 from "./house-album.vue?vue&type=style&index=0&id=52afe617&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52afe617",
  null
  
)

export default component.exports